import { AnimatePresence, motion } from 'framer-motion'
import { useRouter } from 'next/router'
import { useState } from 'react'

import { useExhibitors } from '..'
import { BoothArea, boothAreas, planViewBox } from './booths'
import { halls } from './halls'
import { useExhibitorLocations } from './useExhibitorLocations'

import * as styles from './PlanDesktop.css'

export function PlanDesktop() {
  const router = useRouter()
  const exhibitors = useExhibitors()
  const exhibitorLocations = useExhibitorLocations(exhibitors)

  const [activeArea, setActiveArea] = useState<BoothArea>()

  const activeExhibitor = activeArea ? exhibitorLocations[activeArea.booth] : undefined

  function onClick(area: BoothArea) {
    const exhibitor = exhibitorLocations[area.booth]
    if (exhibitor) {
      router.push(`/aussteller/${exhibitor.slug}`)
    }
  }

  return (
    <div css={styles.wrapper}>
      <AnimatePresence>
        {activeArea && activeExhibitor && (
          <motion.div
            css={styles.active}
            initial={{ opacity: 0, y: '100%' }}
            animate={{ opacity: 1, y: '0' }}
            exit={{ opacity: 0, y: '100%' }}
            style={
              {
                '--color-path-base': halls[activeArea.hall].colorBase,
                '--color-path-text': halls[activeArea.hall].colorText,
              } as any
            }
          >
            <div css={styles.activeBox}>
              <div css={styles.activeMain}>
                <div css={styles.activeBooth}>{activeArea.booth}</div>
                <div css={styles.activeName}>{activeExhibitor.name}</div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <div css={styles.plan}>
        {/* Die Standflaechen liegen hinter dem Plan, damit Umrandung und Standnummer
            beim Hover scharf bleiben und nur die Flaeche heller wird. */}
        <svg css={styles.areas} viewBox={planViewBox} aria-hidden="true" focusable="false">
          {boothAreas.map((area, index) => (
            <rect
              key={`${area.booth}-${index}`}
              data-booth={area.booth}
              data-active={area.booth in exhibitorLocations}
              x={area.x}
              y={area.y}
              width={area.width}
              height={area.height}
              fill={halls[area.hall].color}
              opacity={area.opacity}
              onMouseEnter={() => setActiveArea(area)}
              onMouseLeave={() => setActiveArea(undefined)}
              onClick={() => onClick(area)}
            />
          ))}
        </svg>

        <img src="/LIAN_Ne26_Webseite_Plan_Interaktiv.svg" alt="Hallenplan 2026" css={styles.lineart} />
      </div>
    </div>
  )
}
